import React, { useState } from 'react';
import { Bookmark, Briefcase, BookOpen } from 'lucide-react';
import { useSavedItems } from '../hooks/saved/useSavedItems';
import { SavedJobsList } from '../components/jobs/saved/SavedJobsList';
import { SavedCoursesList } from '../components/courses/saved/SavedCoursesList';

type Tab = 'jobs' | 'courses';

export function SavedItemsPage() {
  const [activeTab, setActiveTab] = useState<Tab>('jobs');
  const { savedJobs, savedCourses } = useSavedItems();

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-7xl mx-auto px-3 sm:px-4">
        <div className="flex items-center space-x-2 mb-6">
          <Bookmark className="h-5 w-5 text-accent-green" />
          <h1 className="text-xl font-bold text-gray-100">Saved Items</h1>
        </div>

        <div className="flex space-x-4 mb-6">
          <TabButton
            active={activeTab === 'jobs'}
            onClick={() => setActiveTab('jobs')}
            icon={<Briefcase className="h-4 w-4" />}
            label="Jobs"
            count={savedJobs.length}
          />
          <TabButton
            active={activeTab === 'courses'}
            onClick={() => setActiveTab('courses')}
            icon={<BookOpen className="h-4 w-4" />}
            label="Courses"
            count={savedCourses.length}
          />
        </div>

        <div className="card">
          {activeTab === 'jobs' ? (
            <SavedJobsList />
          ) : (
            <SavedCoursesList />
          )}
        </div>
      </div>
    </div>
  );
}

interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
  count: number;
}

function TabButton({ active, onClick, icon, label, count }: TabButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center space-x-2 px-4 py-2 rounded-xl text-sm font-medium transition-colors ${
        active
          ? 'bg-accent-green text-black'
          : 'bg-background-card text-gray-400 hover:text-gray-300'
      }`}
    >
      {icon}
      <span>{label}</span>
      <span className="bg-black/20 px-2 py-0.5 rounded-full text-xs">
        {count}
      </span>
    </button>
  );
}